import { render, staticRenderFns } from "./SchemeCard.vue?vue&type=template&id=0d71c032&scoped=true"
import script from "./SchemeCard.vue?vue&type=script&lang=js"
export * from "./SchemeCard.vue?vue&type=script&lang=js"
import style0 from "./SchemeCard.vue?vue&type=style&index=0&id=0d71c032&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d71c032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d71c032')) {
      api.createRecord('0d71c032', component.options)
    } else {
      api.reload('0d71c032', component.options)
    }
    module.hot.accept("./SchemeCard.vue?vue&type=template&id=0d71c032&scoped=true", function () {
      api.rerender('0d71c032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/SchemeCard/components/SchemeCard.vue"
export default component.exports